import { render, staticRenderFns } from "./AdminTagLink.vue?vue&type=template&id=023230e8"
import script from "./AdminTagLink.vue?vue&type=script&lang=js"
export * from "./AdminTagLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports